import {AfterViewInit, Component, Inject, Input, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {EntityServiceClient, ReferenceDto, ReferenceFilterDto} from "@sharedrest/data.restservice";
import {map} from "rxjs/operators";
import {UserService} from "@sharedcommon/services/user.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {lastValueFrom} from "rxjs";
import {
  NeqSelectAutocompleteComponent
} from "@sharedcommon/components/select-autocomplete/neq-select-autocomplete.component";

@Component({
  selector: 'neq-simple-references-search-popin',
  templateUrl: './simple-references-search-popin.component.html',
  styleUrls: ['./simple-references-search-popin.component.css']
})
export class SimpleReferencesSearchPopinComponent implements AfterViewInit {
  @ViewChild(NeqSelectAutocompleteComponent) select: NeqSelectAutocompleteComponent;
  @Input('matDialogTitle') title: string;

  isSubmitDisabled: boolean = false;
  form: FormGroup = new FormGroup({
    reference: new FormControl()
  });
  selected: ReferenceDto;

  constructor(
    private readonly entityService: EntityServiceClient,
    private readonly userService: UserService,
    private readonly dialogRef: MatDialogRef<SimpleReferencesSearchPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, reference: ReferenceDto }
  ) {
    this.selected = this.data.reference;
  }

  search = (searchTerm: string, page: number) => {
    const filters = new ReferenceFilterDto();

    if (searchTerm) {
      filters.label = searchTerm;
      filters.code = searchTerm;
    }
    filters.page = page;
    filters.matchAny = true;

    return lastValueFrom(
      this.entityService.referencesFetch(
        this.userService.getEntity(), filters)
        .pipe(
          map(e => e.data.map(r => {
            return {reference: r, label: `${r.code} - ${r.label}`};
          }))
        )
    )
  };

  onCancel() {
    this.dialogRef.close(false);
  }

  onFormSubmit() {
    this.dialogRef.close(this.form.get('reference').value);
  }

  onChange(event: { reference: ReferenceDto, label: string }) {
    this.selected = event ? event.reference : null;
  }

  ngAfterViewInit(): void {
    // Ugly, but i've no other solution
    // Error: NG0100: ExpressionChangedAfterItHasBeenCheckedError
    // https://blog.simplified.courses/angular-expression-changed-after-it-has-been-checked-error/#real-life-use-cases-and-solving-the-issue
    setTimeout(() => {
      this.select.writeValue(this.data.reference);
    }, 0);
  }
}
